import { BedConfigChipRoot } from './BedConfigChip.styles';

const BED_CONFIG_LABELS = {
  _Double: 'Double bed',
  Twin: 'Twin bed',
};

export default function BedConfigChip({ systemType, guestNormal, compact = false, ...rest }) {
  const label = BED_CONFIG_LABELS[systemType];
  if (!label) return null;
  if (systemType === 'Twin' && guestNormal !== undefined && guestNormal < 2) return null;

  return <BedConfigChipRoot label={label} size="small" variant="outlined" data-test-id="bed-config-chip" compact={compact} {...rest} />;
}
